/* =========================================================
   OVERTOP — Variant Color Dots v3.0.0
   ---------------------------------------------------------
   Lightweight, idempotent color-dot enhancement for Horizon
   variant buttons. Product-page only, event-driven; no global
   MutationObserver so cart drawer morphs stay quiet.
   ========================================================= */

(function () {
  'use strict';

  var VERSION = '3.0.0';
  var scheduled = false;

  window.__OT_VARIANT_DOTS_VERSION = VERSION;

  function detectColors(text) {
    var t = (text || '').toLowerCase();
    var colors = [];
    if (t.indexOf('black') !== -1) colors.push('black');
    if (t.indexOf('grey') !== -1 || t.indexOf('gray') !== -1) colors.push('grey');
    if (t.indexOf('brown') !== -1) colors.push('brown');
    if (t.indexOf('white') !== -1) colors.push('white');
    return Array.from(new Set(colors));
  }

  function enhance(root) {
    root = root || document;
    var labels = root.querySelectorAll('.variant-option__button-label');
    if (!labels.length) return;

    labels.forEach(function (label) {
      if (label.dataset.otColorsInjected === '1') return;

      var textEl = label.querySelector('.variant-option__button-label__text');
      var txt = textEl ? (textEl.textContent || '').trim() : (label.textContent || '').trim();
      var colors = detectColors(txt);
      if (!colors.length) return;

      label.setAttribute('data-colors', colors.join(','));
      label.dataset.otColorsInjected = '1';

      var dots = document.createElement('span');
      dots.className = 'ot-pc-dots';
      dots.setAttribute('aria-hidden', 'true');

      if (textEl) {
        label.insertBefore(dots, textEl);
      } else {
        label.insertBefore(dots, label.firstChild);
      }
    });
  }

  function schedule(root, delay) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      enhance(root || document);
    }, delay == null ? 80 : delay);
  }

  function boot() {
    enhance(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('variant:update', function () {
    schedule(document, 80);
  });

  document.addEventListener('shopify:section:load', function (event) {
    schedule((event && event.target) || document, 80);
  });
})();
